export const pageVariants = {
	initial: { opacity: 0, y: 18 },
	animate: {
		opacity: 1,
		y: 0,
		transition: { duration: 0.35, ease: "easeOut" },
	},
	exit: {
		opacity: 0,
		y: -10,
		transition: { duration: 0.2, ease: "easeIn" },
	},
};

export const sectionVariants = {
	hidden: { opacity: 0, y: 28 },
	visible: {
		opacity: 1,
		y: 0,
		transition: { duration: 0.45, ease: "easeOut" },
	},
};

export const staggerContainer = {
	hidden: {},
	visible: {
		transition: {
			staggerChildren: 0.08,
		},
	},
};

export const softHover = {
	rest: { y: 0, scale: 1 },
	hover: {
		y: -4,
		scale: 1.01,
		transition: { duration: 0.2, ease: "easeOut" },
	},
};
